export default __webpack_public_path__ + "static/media/Stock token for dark mode.7ef3f11e.svg";